import { render, staticRenderFns } from "./MessagesReceived.vue?vue&type=template&id=4f529b63&"
import script from "./MessagesReceived.vue?vue&type=script&lang=js&"
export * from "./MessagesReceived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports